"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
const react_1 = __importDefault(require("react"));
const EditableTitle_1 = require("../EditableTitle");
const RadioButton_styles_1 = require("./RadioButton.styles");
const RadioButton = ({ id, label, checked, onChange, name, disabled, optionalText, translationKey, translationEditHandler, }) => {
    return (react_1.default.createElement(RadioButton_styles_1.Wrapper, { "$disabled": disabled, onClick: !disabled ? onChange : undefined },
        react_1.default.createElement(RadioButton_styles_1.Input, { id: id, type: "radio", checked: checked, onChange: onChange, name: name, disabled: disabled }),
        react_1.default.createElement(RadioButton_styles_1.Label, { "$disabled": disabled, htmlFor: id },
            react_1.default.createElement(EditableTitle_1.EditableTitle, { name: label, editHandler: (isCancelled, value) => translationEditHandler && value && translationEditHandler(isCancelled, value, translationKey), isEditable: !!translationKey })),
        optionalText && react_1.default.createElement(RadioButton_styles_1.OptionalText, null, optionalText)));
};
exports.RadioButton = RadioButton;
//# sourceMappingURL=RadioButton.js.map